// @flow
import _ from 'lodash';
// import moment from 'moment';
// import translate from '../../../../scripts/core/tools/translate';

declare var kendo: any;

export class GroupMakertShareSpreadsheet {
    dataSource: any;
    noFilter: boolean;

    constructor (dataSource: any, noFilter: boolean = false) {
        this.noFilter = noFilter;
        this.dataSource = dataSource;
    }

    create () {
        const sections = [
            { key: 'main', text: '', index: 0 },
            { key: 'areaDealer', text: 'AREA DEMARCADA - DEALER', index: 3 },
            { key: 'areaGroup', text: 'AREA DEMARCADA - GRUPO TOYOTA', index: 12 },
            { key: 'areaToyota', text: 'AREA DEMARCADA - TOYOTA', index: 21 },
            { key: 'areaIndustry', text: 'AREA DEMARCADA - INDÚSTRIA', index: 30 },
            { key: 'areaMono', text: 'MARKET SHARE GRUPO - AREA DEMARCADA MONOATENDIDA', index: 40 },
            { key: 'areaShared', text: 'MARKET SHARE GRUPO - AREA DEMARCADA MULTIATENDIDA', index: 49 },
            { key: 'nationalToyota', text: 'NACIONAL - TOYOTA', index: 58 },
            { key: 'nationalIndustry', text: 'NACIONAL - INDUSTRIA', index: 67 },
            { key: 'nationalMarketShare', text: 'MARKET SHARE TOYOTA - NACIONAL', index: 77 }
        ];

        const sectionColumns = {
            main: [
                { key: 'areaName', text: 'AREA_DEMARCADA' },
                { key: 'dealerNumber', text: 'DN' },
                { key: 'groupName', text: 'GRUPO' }
            ],
            ..._(sections)
                .filter(section => section.key !== 'main')
                .reduce((acc, section) => {
                    acc[section.key] = [
                        { key: 'smallLowCoreSedan', text: 'SMALL LOW CORE SEDAN' },
                        { key: 'smallLowCoreHatchBack', text: 'SMALL LOW CORE HATCH BACK' },
                        { key: 'smallLowCore', text: 'SMALL LOW CORE' },
                        { key: 'midSedan', text: 'MID SD' },
                        { key: 'midPickUp', text: 'MID PICK-UP' },
                        { key: 'midSUV', text: 'MID SUV' },
                        { key: 'midHatchBack', text: 'MID HB' },
                        { key: 'smallSUV', text: 'SMALL SUV' },
                        { key: 'largeSedan', text: 'LARGE SD' }
                    ];

                    if (section.key === 'areaIndustry' || section.key === 'nationalIndustry') {
                        acc[section.key].push({ key: 'others', text: 'OUTROS' });
                    }

                    return acc;
                }, {})
        };

        const baseStyle = {
            textAlign: 'left',
            fontSize: 11,
            verticalAlign: 'center',
            fontFamily: 'Calibri'
        };

        const baseHeaderStyle = {
            color: '#FFFFFF',
            fontSize: 11,
            bold: true,
            textAlign: 'center',
            verticalAlign: 'center',
            fontFamily: 'Calibri'
        };

        const baseColorStyle = {
            main: '#616161',
            areaDealer: '#455a64',
            areaGroup: '#689f38',
            areaToyota: '#d32f2f',
            areaIndustry: '#0288d1',
            areaMono: '#616161',
            areaShared: '#689f38',
            nationalToyota: '#d32f2f',
            nationalIndustry: '#0288d1',
            nationalMarketShare: '#f57c00'
        };

        const baseBorderColorStyle = {
            main: '#eee',
            areaDealer: '#cfd8dc',
            areaGroup: '#dcedc8',
            areaToyota: '#ffcdd2',
            areaIndustry: '#b3e5fc',
            areaMono: '#cfd8dc',
            areaShared: '#dcedc8',
            nationalToyota: '#ffcdd2',
            nationalIndustry: '#b3e5fc',
            nationalMarketShare: '#ffe0b2'
        };

        const baseBackgroundColorStyle = {
            main: '#fafafa',
            areaDealer: '#f9fafb',
            areaGroup: '#fafdf7',
            areaToyota: '#fff5f6',
            areaIndustry: '#f5fcff',
            areaMono: '#f9fafb',
            areaShared: '#fafdf7',
            nationalToyota: '#fff5f6',
            nationalIndustry: '#f5fcff',
            nationalMarketShare: '#fffbf5'
        };

        const headerStyle = _.reduce(sections, (acc, section) => {
            acc[section.key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[section.key] });
            return acc;
        }, {});

        const getCellStyle = (data, key) => {
            return _.assign({}, baseStyle, {
                textAlign: 'center',
                background: baseBackgroundColorStyle[key],
                borderLeft: { color: baseBorderColorStyle[key], size: 1 },
                borderRight: { color: baseBorderColorStyle[key], size: 1 },
                borderTop: { color: baseBorderColorStyle[key], size: 1 },
                borderBottom: { color: baseBorderColorStyle[key], size: 1 }
            });
        };

        const dataSource = _(this.dataSource)
            .groupBy(d => d.tabName)
            .value();

        const sheets = _.map(dataSource, (data) => (
            {
                name: 'GROUP',
                frozenColumns: 3,
                frozenRows: 2,
                filter: {
                    ref: `A2:U${data.length + 2}`,
                    columns: []
                },
                rows: [
                    {
                        index: 0,
                        cells: [
                            ..._.map(sections, (section) =>
                                _.assign({}, headerStyle[section.key], {
                                    value: section.text,
                                    index: section.index,
                                    borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                                    borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                                }))
                        ]
                    },
                    {
                        index: 1,
                        height: 80,
                        cells: [
                            ..._(sectionColumns)
                                .map((columns, key) =>
                                    _.map(columns, (cell) =>
                                        _.assign({}, headerStyle[key], {
                                            value: cell.text,
                                            wrap: true,
                                            borderLeft: { color: baseBorderColorStyle[key], size: 1 },
                                            borderRight: { color: baseBorderColorStyle[key], size: 1 },
                                            borderTop: { color: baseBorderColorStyle[key], size: 1 },
                                            borderBottom: { color: baseBorderColorStyle[key], size: 1 }
                                        })))
                                .flatten()
                                .value()
                        ]
                    },
                    ..._.map(data, d => {
                        return ({
                            cells: [
                                ..._(sectionColumns)
                                    .map((columns, key) =>
                                        _.map(columns, (cell, k) => {
                                            if (key === 'main') {
                                                return _.assign({}, getCellStyle(d[cell.key], key), {
                                                    value: d[cell.key]
                                                });
                                            }
                                            return _.assign({}, getCellStyle(d[key][cell.key], key), {
                                                value: d[key][cell.key]
                                            });
                                        }))
                                    .flatten()
                                    .value()
                            ]

                        });
                    })
                ],
                columns: [
                    {
                        index: 0,
                        width: 160
                    },
                    {
                        index: 1,
                        width: 100
                    },
                    {
                        index: 2,
                        width: 160
                    },
                    ..._.map(_.range(0, 83), index => ({
                        index: index + 3,
                        width: 75
                    }))
                ],
                showGridLines: true,
                mergedCells: [
                    'A1:C1',
                    'D1:L1',
                    'M1:U1',
                    'V1:AD1',
                    'AE1:AN1',
                    'AO1:AW1',
                    'AX1:BF1',
                    'BG1:BO1',
                    'BP1:BY1',
                    'BZ1:CH1'
                ]
            }
        ));

        const workbook = new kendo.ooxml.Workbook({
            sheets
        });

        workbook.saveAsExcel = () => {
            kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: `demo.xlsx`
            });
        };
        return workbook;
    }
}



// WEBPACK FOOTER //
// ./src/spreadsheets/group-market-share-spreadsheet.js